module.exports = __webpack_public_path__ + "static/domain-whois_3-d20fccc96bcc961cea4feb9f8ae16d12.jpg";